var _g, _g2, _path, _g3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHhLogoColor(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 461,
    height: 108,
    viewBox: "0 0 461 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_5761_19017)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.1907 36.1932C46.1907 34.9068 46.9053 33.7269 48.0453 33.131L66.4735 23.4981C68.774 22.2956 71.5294 23.9644 71.5294 26.5603V91.3234C71.5294 92.6098 70.8148 93.7897 69.6748 94.3856L51.2467 104.018C48.9462 105.221 46.1907 103.552 46.1907 100.956V36.1932Z",
    fill: "#FDFBF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6731 5.82861C34.6731 3.23274 31.9177 1.5639 29.6172 2.76645L11.189 12.3994C10.049 12.9953 9.33441 14.1751 9.33441 15.4615V36.5854C9.33441 37.8872 10.0661 39.0785 11.2271 39.6672L29.6553 49.0111C31.9538 50.1765 34.6731 48.5064 34.6731 45.9293V5.82861Z",
    fill: "#FDFBF7"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_dii_5761_19017)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.33441 60.4231V79.5089C9.33441 82.086 12.0538 83.7561 14.3523 82.5907L32.7804 73.2468C33.9415 72.6581 34.6731 71.4668 34.6731 70.1651V69.6371C34.6731 68.3284 33.9337 67.1319 32.7631 66.5466L14.3349 57.3326C12.0375 56.1839 9.33441 57.8545 9.33441 60.4231Z",
    fill: "#4062DD"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M258.896 82.7782C258.391 82.7782 257.962 82.6267 257.608 82.3237C257.255 81.9702 257.078 81.5157 257.078 80.9601V31.6434C257.078 31.0878 257.255 30.6333 257.608 30.2798C257.962 29.9262 258.391 29.7495 258.896 29.7495H265.79C266.345 29.7495 266.775 29.9262 267.078 30.2798C267.431 30.6333 267.608 31.0878 267.608 31.6434V51.1882H289.956V31.6434C289.956 31.0878 290.132 30.6333 290.486 30.2798C290.84 29.9262 291.269 29.7495 291.774 29.7495H298.592C299.147 29.7495 299.602 29.9262 299.955 30.2798C300.309 30.6333 300.486 31.0878 300.486 31.6434V80.9601C300.486 81.4652 300.309 81.8944 299.955 82.248C299.602 82.6015 299.147 82.7782 298.592 82.7782H291.774C291.269 82.7782 290.84 82.6015 290.486 82.248C290.132 81.8944 289.956 81.4652 289.956 80.9601V60.6577H267.608V80.9601C267.608 81.4652 267.431 81.8944 267.078 82.248C266.775 82.6015 266.345 82.7782 265.79 82.7782H258.896ZM319.992 83.5358C316.911 83.5358 314.235 82.854 311.962 81.4904C309.74 80.0763 308.023 78.1067 306.811 75.5815C305.599 73.0058 304.993 69.9756 304.993 66.4908V45.2036C304.993 44.6985 305.169 44.2692 305.523 43.9157C305.876 43.5622 306.306 43.3854 306.811 43.3854H313.477C314.033 43.3854 314.462 43.5622 314.765 43.9157C315.119 44.2692 315.295 44.6985 315.295 45.2036V66.0363C315.295 72.2987 318.048 75.43 323.553 75.43C326.179 75.43 328.249 74.5967 329.765 72.93C331.33 71.2634 332.113 68.9655 332.113 66.0363V45.2036C332.113 44.6985 332.29 44.2692 332.643 43.9157C332.997 43.5622 333.426 43.3854 333.931 43.3854H340.598C341.103 43.3854 341.532 43.5622 341.885 43.9157C342.239 44.2692 342.416 44.6985 342.416 45.2036V80.9601C342.416 81.4652 342.239 81.8944 341.885 82.248C341.532 82.6015 341.103 82.7782 340.598 82.7782H334.461C333.906 82.7782 333.451 82.6015 333.098 82.248C332.795 81.8944 332.643 81.4652 332.643 80.9601V77.8541C331.28 79.6218 329.588 81.0106 327.568 82.0207C325.548 83.0308 323.022 83.5358 319.992 83.5358ZM368.18 83.5358C365.25 83.5358 362.801 83.0308 360.831 82.0207C358.912 81.0106 357.321 79.7228 356.059 78.1572V80.9601C356.059 81.4652 355.882 81.8944 355.529 82.248C355.225 82.6015 354.796 82.7782 354.241 82.7782H348.256C347.751 82.7782 347.322 82.6015 346.968 82.248C346.615 81.8944 346.438 81.4652 346.438 80.9601V30.81C346.438 30.305 346.615 29.8757 346.968 29.5222C347.322 29.1687 347.751 28.9919 348.256 28.9919H354.695C355.251 28.9919 355.68 29.1687 355.983 29.5222C356.337 29.8757 356.513 30.305 356.513 30.81V47.6277C357.776 46.1631 359.342 44.9763 361.21 44.0672C363.129 43.1077 365.452 42.6279 368.18 42.6279C370.856 42.6279 373.18 43.0824 375.149 43.9915C377.119 44.9005 378.76 46.1884 380.073 47.855C381.437 49.4711 382.472 51.365 383.179 53.5367C383.886 55.7083 384.265 58.0567 384.316 60.5819C384.366 61.491 384.391 62.3243 384.391 63.0818C384.391 63.7889 384.366 64.5969 384.316 65.506C384.215 68.1322 383.811 70.5564 383.103 72.7785C382.396 74.9502 381.386 76.8441 380.073 78.4602C378.76 80.0763 377.119 81.3389 375.149 82.248C373.18 83.1065 370.856 83.5358 368.18 83.5358ZM365.377 75.43C367.548 75.43 369.24 74.9754 370.452 74.0664C371.664 73.1068 372.523 71.8695 373.028 70.3544C373.584 68.8393 373.912 67.1726 374.013 65.3545C374.114 63.8394 374.114 62.3243 374.013 60.8092C373.912 58.991 373.584 57.3244 373.028 55.8093C372.523 54.2942 371.664 53.0821 370.452 52.1731C369.24 51.2135 367.548 50.7337 365.377 50.7337C363.357 50.7337 361.715 51.1882 360.453 52.0973C359.19 53.0064 358.23 54.168 357.574 55.5821C356.917 56.9457 356.564 58.385 356.513 59.9001C356.463 60.8092 356.438 61.794 356.438 62.8546C356.438 63.8646 356.463 64.8242 356.513 65.7333C356.614 67.2989 356.943 68.8393 357.498 70.3544C358.104 71.819 359.039 73.031 360.301 73.9906C361.614 74.9502 363.306 75.43 365.377 75.43Z",
    fill: "#FBF7EF"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_5761_19017)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M124.867 82.7782C124.362 82.7782 123.933 82.6267 123.579 82.3237C123.226 81.9702 123.049 81.5157 123.049 80.9601V31.6434C123.049 31.0878 123.226 30.6333 123.579 30.2798C123.933 29.9262 124.362 29.7495 124.867 29.7495H131.761C132.316 29.7495 132.746 29.9262 133.049 30.2798C133.402 30.6333 133.579 31.0878 133.579 31.6434V51.1882H155.927V31.6434C155.927 31.0878 156.104 30.6333 156.457 30.2798C156.811 29.9262 157.24 29.7495 157.745 29.7495H164.563C165.119 29.7495 165.573 29.9262 165.927 30.2798C166.28 30.6333 166.457 31.0878 166.457 31.6434V80.9601C166.457 81.4652 166.28 81.8944 165.927 82.248C165.573 82.6015 165.119 82.7782 164.563 82.7782H157.745C157.24 82.7782 156.811 82.6015 156.457 82.248C156.104 81.8944 155.927 81.4652 155.927 80.9601V60.6577H133.579V80.9601C133.579 81.4652 133.402 81.8944 133.049 82.248C132.746 82.6015 132.316 82.7782 131.761 82.7782H124.867ZM185.889 83.5358C182.809 83.5358 180.132 82.854 177.859 81.4904C175.637 80.0763 173.92 78.1067 172.708 75.5815C171.496 73.0058 170.89 69.9756 170.89 66.4908V45.2036C170.89 44.6985 171.067 44.2692 171.42 43.9157C171.774 43.5622 172.203 43.3854 172.708 43.3854H179.374C179.93 43.3854 180.359 43.5622 180.662 43.9157C181.016 44.2692 181.193 44.6985 181.193 45.2036V66.0363C181.193 72.2987 183.945 75.43 189.45 75.43C192.076 75.43 194.147 74.5967 195.662 72.93C197.227 71.2634 198.01 68.9655 198.01 66.0363V45.2036C198.01 44.6985 198.187 44.2692 198.541 43.9157C198.894 43.5622 199.323 43.3854 199.828 43.3854H206.495C207 43.3854 207.429 43.5622 207.783 43.9157C208.136 44.2692 208.313 44.6985 208.313 45.2036V80.9601C208.313 81.4652 208.136 81.8944 207.783 82.248C207.429 82.6015 207 82.7782 206.495 82.7782H200.359C199.803 82.7782 199.349 82.6015 198.995 82.248C198.692 81.8944 198.541 81.4652 198.541 80.9601V77.8541C197.177 79.6218 195.485 81.0106 193.465 82.0207C191.445 83.0308 188.92 83.5358 185.889 83.5358ZM234.077 83.5358C231.148 83.5358 228.698 83.0308 226.729 82.0207C224.809 81.0106 223.219 79.7228 221.956 78.1572V80.9601C221.956 81.4652 221.779 81.8944 221.426 82.248C221.123 82.6015 220.693 82.7782 220.138 82.7782H214.153C213.648 82.7782 213.219 82.6015 212.865 82.248C212.512 81.8944 212.335 81.4652 212.335 80.9601V30.81C212.335 30.305 212.512 29.8757 212.865 29.5222C213.219 29.1687 213.648 28.9919 214.153 28.9919H220.592C221.148 28.9919 221.577 29.1687 221.88 29.5222C222.234 29.8757 222.411 30.305 222.411 30.81V47.6277C223.673 46.1631 225.239 44.9763 227.107 44.0672C229.027 43.1077 231.35 42.6279 234.077 42.6279C236.754 42.6279 239.077 43.0824 241.046 43.9915C243.016 44.9005 244.657 46.1884 245.971 47.855C247.334 49.4711 248.369 51.365 249.076 53.5367C249.784 55.7083 250.162 58.0567 250.213 60.5819C250.263 61.491 250.289 62.3243 250.289 63.0818C250.289 63.7889 250.263 64.5969 250.213 65.506C250.112 68.1322 249.708 70.5564 249.001 72.7785C248.294 74.9502 247.284 76.8441 245.971 78.4602C244.657 80.0763 243.016 81.3389 241.046 82.248C239.077 83.1065 236.754 83.5358 234.077 83.5358ZM231.274 75.43C233.446 75.43 235.137 74.9754 236.35 74.0664C237.562 73.1068 238.42 71.8695 238.925 70.3544C239.481 68.8393 239.809 67.1726 239.91 65.3545C240.011 63.8394 240.011 62.3243 239.91 60.8092C239.809 58.991 239.481 57.3244 238.925 55.8093C238.42 54.2942 237.562 53.0821 236.35 52.1731C235.137 51.2135 233.446 50.7337 231.274 50.7337C229.254 50.7337 227.612 51.1882 226.35 52.0973C225.087 53.0064 224.128 54.168 223.471 55.5821C222.815 56.9457 222.461 58.385 222.411 59.9001C222.36 60.8092 222.335 61.794 222.335 62.8546C222.335 63.8646 222.36 64.8242 222.411 65.7333C222.512 67.2989 222.84 68.8393 223.395 70.3544C224.001 71.819 224.936 73.031 226.198 73.9906C227.511 74.9502 229.203 75.43 231.274 75.43Z",
    fill: "#4062DD",
    fillOpacity: 0.85,
    shapeRendering: "crispEdges"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_5761_19017",
    x: 9.33441,
    y: 2.36865,
    width: 63.9432,
    height: 102.63,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.7482
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.16547
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_5761_19017"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.582734
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.728417
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.768627 0 0 0 0 0.768627 0 0 0 0 0.768627 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_5761_19017",
    result: "effect2_innerShadow_5761_19017"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_dii_5761_19017",
    x: 0.593405,
    y: 48.2223,
    width: 42.8207,
    height: 43.4874,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.3705
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.249167 0 0 0 0 0.385017 0 0 0 0 0.866667 0 0 0 0.85 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5761_19017"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5761_19017",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.16547
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.728417
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.142604 0 0 0 0 0.178495 0 0 0 0 0.308333 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_5761_19017"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.582734
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.728417
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.356823 0 0 0 0 0.478965 0 0 0 0 0.920833 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_5761_19017",
    result: "effect3_innerShadow_5761_19017"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_5761_19017",
    x: 120.135,
    y: 26.0782,
    width: 133.067,
    height: 60.3712,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.45683
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.301961 0 0 0 0 0.431373 0 0 0 0 0.87451 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5761_19017"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5761_19017",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHhLogoColor);
export default __webpack_public_path__ + "static/media/hh-logo-color.d438e952fbe7bfa6af5a4f3ae79a28fe.svg";
export { ForwardRef as ReactComponent };